import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indianNumber',
    standalone: false
})
export class IndianNumberPipe implements PipeTransform {
  public transform(value: number | string): string {
    if (value === null || value === undefined || value === '') return '';

    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return String(value);

    const [integerPart, decimalPart] = num.toFixed(0).split('.');
    const lastThree = integerPart.substring(integerPart.length - 3);
    const otherNumbers = integerPart.substring(0, integerPart.length - 3);

    const formattedOtherNumbers = otherNumbers !== ''
      ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + ',' + lastThree
      : lastThree;

    return formattedOtherNumbers;
  }
}